import { Injectable, OnInit } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from "@angular/router";
import { tap } from 'rxjs/operators';
import { ToastrService } from "ngx-toastr";
import { AuthService } from "../shared/services/auth.service";
import { DatePipe } from "@angular/common";



@Injectable()

export class AuthInterceptor implements HttpInterceptor {
    constructor(
        private authService: AuthService,
        private router: Router,
        private toastrService: ToastrService

    ) { }

    currentUser: any;
    datepipe: DatePipe = new DatePipe('en-US')


    ngOnInit(): void {
        this.currentUser = this.authService.currentUserValue;
    }

    getCurrentDateTime() {
        let hours: any = new Date().getHours();
        if (hours < 10) {
            hours = `0${hours}`
        }
        let min: any = new Date().getMinutes();
        if (min < 10) {
            min = `0${min}`
        }

        let year: any = new Date().getFullYear();
        let month: any = new Date().getMonth() + 1;
        let date: any = new Date().getDate();

        if (month < 10) {
            month = `0${month}`
        }
        if (date < 10) {
            date = `0${date}`
        }
        return `${year}-${month}-${date}T${hours}:${min}:00.000Z`;
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const basicAuthDetails = this.authService.basicAuthentication;
        const currentUser = this.authService.currentUserValue;


        if (Object.keys(currentUser).length) {

            let url = request.url;
            if (url != 'https://api.stripe.com/v1/tokens') {
                request = request.clone({
                    setHeaders: {
                        'accessToken': currentUser.accessToken,
                        'Authorization': 'Basic ' + btoa(basicAuthDetails.userName + ':' + basicAuthDetails.password),
                        'currentDate': `${this.getCurrentDateTime()}`,
                    }
                })
            } else {
                request = request.clone({
                    setHeaders: {
                        'accessToken': currentUser.accessToken,
                        // 'Authorization': 'Bearer pk_live_51Mwn3PF6k8u4g0kS8U3F1BZZIHblly6KtVP0t6REcMet7QsvPs6ZUs2MMuhZNbSAwz8YzAUlSv5OGu81VlQNUp4u00MBnKvE4H',
                        'Authorization': 'Bearer pk_test_51Rfo41PLIPq0nHQwiNsG6dmzxeenbE8jfMHq44mtbzpIx6BDf4Z4skUZHlQbC7iotk5tSgGb2DnMeh7pXicbQo2T004oIuB8Gl',
                        // 'Authorization': 'Bearer pk_test_51Rfo41PLIPq0nHQwiNsG6dmzxeenbE8jfMHq44mtbzpIx6BDf4Z4skUZHlQbC7iotk5tSgGb2DnMeh7pXicbQo2T004oIuB8Gl',
                        'currentDate': `${this.getCurrentDateTime()}`,
                    }

                })
            }

        } else {
            request = request.clone({
                setHeaders: {
                    'Authorization': 'Basic ' + btoa(basicAuthDetails.userName + ':' + basicAuthDetails.password),
                    'currentDate': `${this.getCurrentDateTime()}`,
                }
            })
        }

        return next.handle(request).pipe(
            tap(
                event => {
                    if (event instanceof HttpResponse) {
                        if (event.body.status == 401) {
                            if (event.body.error.status == 44) {
                                this.router.navigate(['/login']);
                                this.toastrService.error("Session expired please re-login again");
                            } else {
                                this.router.navigate(['/login']);
                                this.toastrService.error('Invalid email or password');
                            }
                        }
                    }
                },
                error => {

                    if (error?.status == 403) {
                        this.router.navigate(['/']);
                        this.toastrService.error(error.error.error.message);
                        // location.reload();
                    }
                    if (error?.status == 401) {
                        this.router.navigate(['/']);
                        this.toastrService.error(error.error.error.message);
                        // location.reload();
                    }
                }
            )
        );
    }
}
